module.exports = __webpack_public_path__ + "static/media/VFD.f6608e68.png";